<template lang="pug">
  .center
    section.custom-width.margin-top
      el-row(:gutter="16")
        el-col(:xs="24", :sm="12", :md="12")
          h5.text-primary  Nossa especialidade
          h2
            |Edição e produção
            span.space
            span.text-secondary de conteúdo
          p Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla lacinia diam risus, vitae bibendum sapien iaculis sit amet. Morbi eleifend ipsum vitae lorem gravida, quis scelerisque velit maximus. Praesent ornare, est a fringilla volutpat, nibh diam suscipit mauris, eget maximus nibh ex id magna. Sed tristique ex sed sollicitudin lobortis. Nulla porta porta rhoncus. Phasellus viverra neque at metus fermentum pellentesque. Fusce fringilla luctus purus, vel auctor nibh. Nam volutpat vel magna ac rutrum. Aliquam vitae augue at ipsum tempor ullamcorper.
          el-button.bold.btn-custom(round, type="danger", data-aos="fade-up", data-aos-delay="300")
            |Vamos começar
            span.space
            i.el-icon-right
        el-col(:xs="24", :sm="12", :md="12")
          .box-img
            img(data-aos="fade-left", data-aos-delay="700", :src="require('@/assets/svg/web-bg.svg')")
</template>

<script>
  export default {
    name: 'what-we-box',
    computed: {
      collapseMenu () {
        let self = this
        if (parseInt(self.$root.screenW) < 768) {
          return true
        }
        return false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  h5
    font-size: $f-size*1.1
  h2
    font-family: 'Kanit', sans-serif
  p
    margin: 64px 0
  .box-img
    background-image: url('../../assets/svg/shape-bg.svg')
    background-size: 100%
    background-position: right
    background-repeat: no-repeat
    padding-left: 10%
    margin-left: -10%
    img
      width: 100%
</style>